import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * MuiAlertBase
 */
export const MuiAlertBase = {};

/**
 * MuiAlert
 *
 * Demos:
 *
 * - [Alert](https://ui-packages.isbuildingluma.com/ui-core/react-alert/)
 *
 * API:
 *
 * - [Alert API](https://ui-packages.isbuildingluma.com/ui-core/api/alert/)
 * - inherits [MuiAlert API](https://mui.com/material-ui/api/alert/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/design/WJDRbOCCrGVDTsbUC3yvp8/Luma-Design-System?node-id=3108-28049&node-type=frame&t=xVtSqOYK7MKIyCvM-0)
 */
const MuiAlert = {
  defaultProps: {
    variant: 'filled'
  },
  styleOverrides: {
    action: ({
      theme
    }) => ({
      fontSize: '1.5rem',
      alignItems: 'center',
      padding: 0,
      '& .MuiSvgIcon-fontSizeSmall': {
        fontSize: '1.5rem'
      },
      color: theme.palette.text.primary
    }),
    message: ({
      theme
    }) => _extends({}, theme.typography.body2, {
      color: theme.palette.text.secondary,
      '& .MuiAlertTitle-root': _extends({}, theme.typography.subtitle1, {
        color: theme.palette.text.primary,
        marginBottom: 0
      })
    }),
    icon: {
      alignItems: 'center'
    },
    filled: {
      border: '2px solid'
    },
    filledError: ({
      theme
    }) => ({
      backgroundColor: theme.palette.error[100],
      borderColor: theme.palette.error.main,
      '& .MuiAlert-icon': {
        color: theme.palette.error.main
      }
    }),
    filledInfo: ({
      theme
    }) => ({
      backgroundColor: theme.palette.primary[100],
      borderColor: theme.palette.primary.main,
      '& .MuiAlert-icon': {
        color: theme.palette.primary.main
      }
    }),
    filledSuccess: ({
      theme
    }) => ({
      backgroundColor: theme.palette.success.light,
      borderColor: theme.palette.success.main,
      '& .MuiAlert-icon': {
        color: theme.palette.success.main
      }
    }),
    filledWarning: ({
      theme
    }) => ({
      backgroundColor: theme.palette.quaternary.light,
      borderColor: theme.palette.quaternary.dark,
      '& .MuiAlert-icon': {
        color: theme.palette.quaternary.dark
      }
    }),
    outlined: {
      backgroundColor: 'Background'
    },
    outlinedError: ({
      theme
    }) => ({
      borderColor: theme.palette.error.main,
      '& .MuiAlert-icon': {
        color: theme.palette.error.main
      }
    }),
    outlinedWarning: ({
      theme
    }) => ({
      borderColor: theme.palette.quaternary.dark,
      '& .MuiAlert-icon': {
        color: theme.palette.quaternary.dark
      }
    }),
    outlinedInfo: ({
      theme
    }) => ({
      borderColor: theme.palette.primary.main,
      '& .MuiAlert-icon': {
        color: theme.palette.primary.main
      }
    }),
    outlinedSuccess: ({
      theme
    }) => ({
      borderColor: theme.palette.success.main,
      '& .MuiAlert-icon': {
        color: theme.palette.success.main
      }
    }),
    root: ({
      theme
    }) => {
      return {
        '&.MuiAlert-smallSize': {
          padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
          borderWidth: '1px',
          '& .MuiAlert-message': _extends({}, theme.typography.body2, {
            color: theme.palette.text.secondary,
            lineHeight: 1
          }),
          '& .MuiAlert-action': {
            fontSize: '.875rem',
            alignItems: 'center',
            '& .MuiSvgIcon-fontSizeSmall': {
              fontSize: '.875rem'
            }
          }
        }
      };
    }
  }
};
export default MuiAlert;